import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";


const firebaseConfig = {
  apiKey: "AIzaSyBIXpd6kB38IQIpp5D0refNVzVqZihzDK8",
  authDomain: "autocharge-349200.firebaseapp.com",
  projectId: "autocharge-349200",
  storageBucket: "autocharge-349200.appspot.com",
  messagingSenderId: "161019324987",
  appId: "1:161019324987:web:c5fa18766bf55966218a1e",
  measurementId: "G-LNFF9NXFX8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
 export const initializeAnalytics = getAnalytics(app);